"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFilters = exports.attachmentSearchItemsConfig = void 0;
var attachmentSearchItemsConfig = [{
  label: 'image',
  key: 'image'
}, {
  label: 'video',
  key: 'video'
}, {
  label: 'file',
  key: 'file'
}];
exports.attachmentSearchItemsConfig = attachmentSearchItemsConfig;
var defaultFilters = {
  from: [],
  mentions: [],
  has: []
};
exports.defaultFilters = defaultFilters;